//退货API
import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findRefundList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/list?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2Return = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/return?` + params,
        method: 'GET'
    })
}
export const findRefundFormDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/detail/${id}`,
        method: 'GET',
    })
}
export const invoiceSystemV2ReturnDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/return/${id}`,
        method: 'GET',
    })
}
export const invoiceSystemV2ReturnDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/return/downloadExcel?` + params,
        method: 'GET'
    })
}

export const agreeToReturn = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/refund/${id}`,
        method: 'GET'
    })
}
export const invoiceSystemV2ReturnPass = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/return/pass/${id}`,
        method: 'PUT'
    })
}



export const refuseToReturn = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/dissident/${id}?` + params,
        method: 'GET'
    })
}


export const invoiceSystemV2ReturnRefuse = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/return/refuse/${id}?` + params,
        method: 'PUT'
    })
}




export const downloadPDF = (id) => {
    let url = `${baseUrl}` + `/joins-invoice-system/v1/exit/exportPdfPurchaseExit/${id}`
    window.open(url);
}